import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { makePost } from "../../utils/fetchUtils";
import { SEND_OTP } from "../../utils/constants";
import nclude from "../../assets/nclude.svg";
import sticker1 from "../../assets/sticker1.svg";
import curve1 from "../../assets/curve.svg";
import useWindowWidth from "../../utils/windowWidth";

const VerifyRequest = () => {
  const location = useLocation();
  const mainRef = useRef<HTMLHeadingElement>(null);
  const email = (location.state as { email?: string })?.email || "your email";

  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg] = useState("");

  useEffect(() => {
    document.title = "Verification Link Sent - Nclude Portal";
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  const handleResendLink = async () => {
    if (!email || email === "your email") return;
    setResendLoading(true);
    setResendMsg("");
    try {
      const resp = await makePost(SEND_OTP, JSON.stringify({ email }));
      setResendLoading(false);
      if (resp && resp.success !== false) {
        setResendMsg("A new verification link has been sent to your email!");
      } else {
        setResendMsg(resp.message || "Failed to resend link. Please try again.");
      }
    } catch (err: any) {
      setResendLoading(false);
      setResendMsg("Failed to resend link. Please try again.");
    }
  };

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="auth-page flex items-center login-form" style={{ minHeight: isMobile ? "50vh" : "100vh" }} role="main">
      <div className="logo-container">
        <div className="flex justify-center items-center h-screen w-full">
          <div className="flex flex-col items-start">
            <img src={nclude} alt="Nclude logo" className="logo mb-3" />
            <div className="flex flex-col items-start text-container">
              <img src={sticker1} alt="" aria-hidden="true" className="sticker1 mb-2" />
              <img src={curve1} alt="" aria-hidden="true" className="curve1 mb-4" />
              <h3 className="text-left font-normal">
                Resources <br />
                and opportunities for <span className="font-bold tracking-normal text-white">People with Disabilities</span>
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div className="auth-form-container flex flex-col items-center">
        <div className="auth-form text-center py-6">
          <div className="w-16 h-16 bg-purple-100 text-[#5030E5] rounded-full flex items-center justify-center mx-auto mb-4 text-3xl">
            ✉️
          </div>
          <h1
            className="mb-3 text-[2rem]"
            ref={mainRef}
            tabIndex={-1}
            style={{ fontWeight: 600, lineHeight: "2.375rem" }}
          >
            Verification Link Sent
          </h1>
          <p className="text-gray-700 text-base mb-6 max-w-md mx-auto">
            A verification link has been sent to <strong>{email}</strong>. Please check your inbox and verify your email to continue.
          </p>

          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg max-w-md mx-auto mb-6">
            <p className="text-xs text-gray-600 mb-2">
              Didn't receive the email? Check your spam folder or resend the link.
            </p>
            <button
              type="button"
              className="text-[#5030E5] font-semibold text-sm underline hover:text-purple-800"
              onClick={handleResendLink}
              disabled={resendLoading || email === "your email"}
            >
              {resendLoading ? "Resending Link..." : "Resend Verification Link"}
            </button>
            {resendMsg && (
              <p className="text-green-700 text-xs mt-2 font-semibold" role="status">
                {resendMsg}
              </p>
            )}
          </div>

          <h2 style={{ fontSize: "1rem", fontWeight: 500 }} className="mt-8 text-right">
            Already verified?{" "}
            <Link to="/login" className="text-[#5030E5]" style={{ textDecoration: "underline" }}>
              Back to Login
            </Link>
          </h2>
        </div>
      </div>
    </div>
  );
};

export default VerifyRequest;
